/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_LabelInputs */

const en_company_registration_label = /** @type {(inputs: Company_Registration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registration no.`)
};

/**
* | output |
* | --- |
* | "Registration no." |
*
* @param {Company_Registration_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const company_registration_label = /** @type {((inputs?: Company_Registration_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_company_registration_label(inputs)
});